import React from "react"
import tw from "twin.macro"
import styled from "@emotion/styled"

import { StyledButton } from "../../Styled/Button"
import CartLabel from "../CartLabel"
import { withCartCheckout } from "./withCartCheckout"
// import { StyledH2 } from "../../Styled/Text"

const Wrapper = tw.div`w-full flex flex-col text-center pt-3-2`
const ButtonWrapper = tw.div`w-full px-2-4`
const CheckoutButton = styled(StyledButton)`
  ${tw`w-full`}
  background: #45976D;

  &:hover {
    background: #f6c5f3;
  }
`

const LabelWrapper = tw.div`pb-3-2 w-full`
const FooterText = tw.div``

export const CartCheckout = withCartCheckout(
  ({
    subtotalPrice,
    count,
    handleCheckout,
    additionalCheckoutButton,
    additionalGeneralFeatureContentsOne,
    additionalGeneralFeatureContentsTwo,
    additionalFooterText,
  }): JSX.Element => (
    <Wrapper>
      <ButtonWrapper>
        <CheckoutButton
          disabled={!count || count < 1}
          onClick={handleCheckout}
          layout={`primary`}
          className={`primary_button`}
          colour={`transparent`}
          textsize={`primary-md`}
        >{`${additionalCheckoutButton ? additionalCheckoutButton : "Checkout Now"} | ${subtotalPrice}`}</CheckoutButton>
      </ButtonWrapper>
      {additionalGeneralFeatureContentsOne.length > 0 || additionalGeneralFeatureContentsTwo.length > 0 ? (
        <LabelWrapper>
          {additionalGeneralFeatureContentsOne ? <CartLabel contents={additionalGeneralFeatureContentsOne} startFromLeft={false} /> : null}
          {additionalGeneralFeatureContentsTwo ? <CartLabel contents={additionalGeneralFeatureContentsTwo} startFromLeft={false} /> : null}
        </LabelWrapper>
      ) : null}
      {additionalFooterText ? (
        // <StyledH2>{additionalFooterText}</StyledH2>
        <FooterText className="footer_heading">{additionalFooterText}</FooterText>
      ) : null}
    </Wrapper>
  )
)
